import React from 'react'
// components
import NodeContent from 'components/PageComponents/Plans/Edit/components/ObjectivesList/ObjectivesTreeTheme/NodeContent'
// context
import NodeContentBL from './layers/BL'

const NodeContentContainer = props => (
  <NodeContentBL {...props}>
    <NodeContent {...props} />
  </NodeContentBL>
)

export default NodeContentContainer
